const terrain_manager = {
        title: String("Farms"),
        terrainsDetailsTitle: String("Farm details, {terrain_name}"),
        terrainsDetailsNewTerrainTitle: String("Create new farm"),
        terrainName: String("Finca name"),
        terrainGoogleAskAddress: String("You can use the following input to search the address or manually fill in the fields"),
        terrainAddressStreet: String("Address"),
        terrainAddressNumber: String("Number"),
        terrainAddressMunicipality: String("Municipality"),
        terrainAddressMunicipalityCode: String("Municipality Code"),
        terrainAddressProvince: String("Province"),
        terrainAddressPostalCode: String("Postal Code"),
        terrainAddressRegion: String("Region or region"),
        terrainAddressCountry: String("Country"),
        terrainArea: String("Surface (in hectares)"),
        terrainElevation: String("Altitude above sea level)"),
        terrainHomogeneousGrowingArea: String("Homogeneous Cultivation Zone"),
        terrainCoordinates: String("Coordinates"),
        reportFrequency: String("SHIPPING PERIOD"),
        terrainFrequencyInfoPopover: String("Frequency to which the reports of this land will be sent.The shipment is made once the period established from the last shipment and early in the day is fulfilled."),
        reportLatestSent: String("Date and time of the last shipment:"),
        reportEmails: String("Electronic reports"),
        terrainEmailsInfoPopover: String("The emails listed below will be those that will receive the reports of this land."),
        terrainReportEmailPlaceholder: String("Introduce Email here"),
        terrainPlotAddNew: String("Add new plot"),
        terrainPlotNameHeader: String("Name of the plot"),
        terrainPlotActionHeader: String("Actions"),
        terrainPlotCropTypeHeader: String("Type of crop"),
        terrainPlotAreaHeader: String("Plot surface"),
        terrainPlotSigpacCodeHeader: String("SIGPAC Code"),
        terrainPlotActionModify: String("Modify"),
        terrainPlotNoPlotInList: String("There is no plot associated with this farm."),
        terrainNewTerrainButton: String("Create farm"),
        terrainUpdate: String("Update farm data"),
        terrainRestore: String("Restore all fields"),
        weekly: String("Weekly"),
        daily: String("Diary"),
        monthly: String("Monthly"),
        yearly: String("Annual"),
        profileNavButton: String("Exploitation data"),
        plotsNavButton: String("List of plots"),
        reportNavButton: String("Customize report"),
        terrainNameInfoPopover: String("The name of the farm will be referenced from the reports as well as the management of plots."),
        terrainAddressStreetInfoPopover: String("Postal address of the farm."),
        terrainAddressNumberInfoPopover: String("Number.In case of being an address without number, leave it by default."),
        terrainAddressMunicipalityInfoPopover: String("Municipality to which the farm belongs."),
        terrainAddressMunicipalityCodeInfoPopover: String("Municipality Code.In case of not knowing, leave it by default."),
        terrainAddressProvinceInfoPopover: String("PROVINCE OF THE FINCA."),
        terrainAddressPostalCodeInfoPopover: String("Postal Code."),
        terrainAddressRegionInfoPopover: String("Region to which the province or municipality belongs."),
        terrainAddressCountryInfoPopover: String("Farm country."),
        terrainAreaInfoPopover: String("Farm surface in hectares."),
        terrainElevationInfoPopover: String("Altitude regarding sea level."),
        terrainHomogeneousGrowingAreaInfoPopover: String("Homogeneous culture zone.Symbolical name to group through areas of the same type of crop."),
        terrainCoordinatesInfoPopover: String("Farm coordinates.Must have the following format: latitude, length"),
        terrainNamePlaceholder: String("Finca name ..."),
        terrainGoogleAskAddressPlaceholder: String("Look here for the address ..."),
        terrainAddressStreetPlaceholder: String("Street or polygon ..."),
        terrainAddressNumberPlaceholder: String("0"),
        terrainAddressMunicipalityPlaceholder: String("Municipality or city ..."),
        terrainAddressMunicipalityCodePlaceholder: String("00000"),
        terrainAddressProvincePlaceholder: String("Province..."),
        terrainAddressCountryPlaceholder: String("Country..."),
        terrainAddressRegionPlaceholder: String("Region..."),
        terrainAddressPostalCodePlaceholder: String("00000"),
        terrainHomogeneousGrowingAreaPlaceholder: String("Zone 0"),
        terrainCoordinatesPlaceholder: String("41.1164879, 1.2623967"),
        errorFieldRequired: String("This field is required"),
        errorInvalidLength: String("This field requires a minimum of {length} characters"),
        errorNegativeNumber: String("Only positive numbers"),
        errorCoordinatesIncorrect: String("The format of the coordinates is incorrect."),
        errorNameAlreadyExists: String("There is already a farm with this name."),
        errorsModalTitle: String("ERRORS IN THE FINCA"),
        errorsModalBodyTitle: String("The farm has not been created/updated due to the following errors:"),
        errorProfileFieldsLeft: String("Some of the fields of the section of exploitation data is invalid or incomplete."),
        errorReportFieldsLeft: String("Some of the fields of the section of Customizing report is invalid or incomplete."),
        errorsModalCloseButton: String("Close"),
        errorEmailInvalid: String("Invalid email"),
        reportRequestTitle: String("Report Download Menu"),
        reportRequestTerrainNoModules: String("The report has not been generated because there are no stations associated with the farm"),
        reportRequestDownloadButton: String("Download the report"),
        reportRequestWaitingForResponse: String("Generating the report"),
};

export default terrain_manager;